module.exports = __webpack_public_path__ + "static/playgroup-3-8f5ca5433ee04736910596ff48601650.jpg";